import styled from 'styled-components'

export const VehiclesContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`
